export default "__VITE_ASSET__CkGuEMa1__"